<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Alta de Cliente</h4>
            </div>
            <div class="card-body">
                        <div class="float float-md-right">
                                <div>
                                    <label style="font-size: 20px">1.- Selecciona el tipo de cliente: &nbsp;</label>
                                    <input class="btn btn-outline-info" type="button" value="Persona Física" (click)="tipoCliente('FISICA', 1)">
                                    <input class="btn btn-outline-info" type="button" value="Persona Moral" (click)="tipoCliente('MORAL', 2)">
                                    <input class="btn btn-outline-info" type="button" value="Cliente Especial" (click)="tipoCliente('ESPECIAL', 3)">
                                    <input class="btn btn-outline-info" type="button" value="Cuantia Menor" (click)="tipoCliente('CUANTIA_MAYOR', 4)">
                                </div>
                        </div>
                        <div id="infoBasicaId" class="infoBasica" hidden="true">
                            <br>
                            <br>
                            <br>
                            <hr class="m-t-0 m-b-40">
                            <label style="font-size: 20px">2.- Rellenar los campos de Informacion Basica &nbsp;</label>
                            <br>
                            <br>
                           

                            <div class="row col-md-12 col-xl-6 float-left">
                                    <!-- Columna -->
                                    <!-- En los div´s se le asigna un ID. Esto se utiliza para cambiar/activar los input, dependiendo el tipo de cliente que seleccione el usuario -->
                                    <!-- Nombre -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-12">{{FORMS.crearCliente.nombre.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letras form-control" name="nombre" [(ngModel)]="cliente.nombre" required maxlength="40" minlength="3" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Paterno -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-12">{{ FORMS.crearCliente.paterno.titulo }}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letras form-control" name="paterno" [(ngModel)]="cliente.paterno" required maxlength="30" minlength="3" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Materno -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-12">{{ FORMS.crearCliente.materno.titulo }}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letras form-control" name="materno" [(ngModel)]="cliente.materno" required maxlength="30" minlength="3" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- RFC -->
                                    <div id="rfcColum" class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.rfc.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" id="rfcDocument" class="form-control" name="rfc" [(ngModel)]="cliente.rfc" (ngModelChange)="controlInputs()" required maxlength="18" minlength="10" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Email -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.email.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="email" class="correo form-control" [placeholder]="FORMS.crearCliente.email.placeholder" [(ngModel)]="cliente.email" name="email" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Razón Social -->
                                    <div id="razonSocialText" hidden="true" class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.razonSocial.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" [(ngModel)]="cliente.razonSocial" name="razonSocial" [disabled]="deshabilitarRS">
                                            </div>
        
                                    </div>
                                </div>
                                <!-- /Columna -->
                                <!-- Calle -->
                                <div class="row col-md-12 col-xl-6 float-left">
                                    <!-- Columna -->
                                    <!-- Calle -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.calle.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letrasNumeros form-control" [placeholder]="FORMS.crearCliente.domicilioCliente" [(ngModel)]="cliente.calle" name="calle" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Número Exterior/Interior -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.noext.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letrasNumeros form-control" [placeholder]="FORMS.crearCliente.domicilioCliente" [(ngModel)]="cliente.noExt" name="noext" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.noint.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letrasNumeros form-control" [placeholder]="FORMS.crearCliente.domicilioCliente" [(ngModel)]="cliente.noInt" name="noint" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Colonia y delegación -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.colonia.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letrasNumeros form-control" [placeholder]="FORMS.crearCliente.domicilioCliente" [(ngModel)]="cliente.colonia" name="colonia" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.delegacion.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="letrasNumeros form-control" [placeholder]="FORMS.crearCliente.domicilioCliente" [(ngModel)]="cliente.municipio" name="delegacion" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Código postal -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.codigopostal.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" [placeholder]="FORMS.crearCliente.domicilioCliente" [dropSpecialCharacters]="true" mask="00000" [(ngModel)]="cliente.cp" name="cp" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <!-- Teléfono y celular -->
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.telefono.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" [dropSpecialCharacters]="true" mask="(00) 000000-000000" [(ngModel)]="cliente.telefono" name="telefono" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    <div class="col-md-12">
    
                                            <label class="col-md-6">{{ FORMS.crearCliente.celular.titulo}}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" [dropSpecialCharacters]="true" mask="(000) 00-0000-0000-0000-0000" [(ngModel)]="cliente.celular" name="celular" [disabled]="deshabilitarCampos">
                                            </div>
        
                                    </div>
                                    &nbsp;
                                    <br>
                                    <br>
                                    <br>
                                </div>
                                <br>
                                <button class="btn btn-primary" type="button" *ngIf="tablaDeContactos.length <= 3" data-toggle="modal" data-target="#miModal" [disabled]="deshabilitarBoton">
                                        Agregar Contactos
                                    </button>
                                    <button class="btn btn-secundary" type="button" (click)="documentacion()">
                                            Omitir Contactos
                                        </button>
                                    <br><br>
                        </div>
                        <!-- Termina Info Basica-->
                        <br>
                        <!-- Contactos-->
                        <div id="contactos">
                                <div class="card-body" *ngIf=" tablaDeContactos.length != 0 ">
                                        <table class="table color-table red-table">
                                            <thead>
                                                <tr>
                                                    <th>Nombre completo</th>
                                                    <th>Puesto</th>
                                                    <th>Correo</th>
                                                    <th>Teléfono</th>
                                                    <th>Celular</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let dato of tablaDeContactos; index as i">
                                                    <td>{{ dato.nombre }}</td>
                                                    <td>{{ dato.puesto }}</td>
                                                    <td>{{ dato.email }}</td>
                                                    <td>{{ dato.telefono }}</td>
                                                    <td>{{ dato.celular }}</td>
                                                    <td>
                                                        <a (click)="eliminarContacto(dato.contactoNombre)" data-toggle="tooltip" data-original-title="Close">
                                                            <i class="fa fa-close text-danger"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                        </div>
                        <!-- Contactos Fin -->
                        <br>
                        <br>
                        <!-- documentacion-->
                        <div hidden="true" id="documentacion">
                                <label style="font-size: 20px">3.- Subida de documentos. Sube los documentos que te manda el cliente, editalos despues</label>
                                <div id="generarInputs">
                                            <div id="documentosInputs">
                                                <!-- === -->
                               <!-- INE -->
                               <!-- === -->
                               <div class="form-group col-sm-12 col-md-12 col-lg-12">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.ine.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" id="INE" accept="image/png, image/jpg, image/jpeg, application/pdf" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="ine" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()"/>
                                    </div>
                                </div>
                                <!-- === -->
                                <!-- INE -->
                                <!-- === -->
                                <!-- ========= -->
                               <!-- DOMICILIO -->
                               <!-- ========= -->
                               <div class="form-group col-sm-12 col-md-12 col-lg-12">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.domicilio.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" id="DOMICILIO" accept="image/png, image/jpg, image/jpeg, application/pdf" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="domicilio" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()"/>
                                    </div>
                                </div>
                                <!-- ========= -->
                                <!-- DOMICILIO -->
                                <!-- ========= -->
                                <!-- === -->
                               <!-- SAT -->
                               <!-- === -->
                               <div id="SAT" hidden="true" class="form-group col-sm-12 col-md-12 col-lg-12t">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.sat.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" data-show-loader="true" accept="image/png, image/jpg, image/jpeg, application/pdf" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="sat" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()" [disabled]="deshabilitarCampos" required/>
                                    </div>
                                </div>
                                <!-- === -->
                                <!-- SAT -->
                                <!-- === -->
                                 <!-- ========================= -->
                               <!-- ESTADO DE CUENTA BANCARIO -->
                               <!-- ========================= -->
                               <div id="EDOCTABAN" class="form-group col-sm-12 col-md-12 col-lg-12">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.caratula_bancaria.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" data-show-loader="true" accept="image/png, image/jpg, image/jpeg, application/pdf" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="domicilio" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()" [disabled]="deshabilitarCampos" required/>
                                        
                                    </div>
                                    
                                </div>
                                <!-- ========================= -->
                                <!-- ESTADO DE CUENTA BANCARIO -->
                                <!-- ========================= -->
                                <!-- === -->
                                <!-- INE -->
                                <!-- === -->
                                <div class="form-group col-sm-12 col-md-12 col-lg-12">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.avalIne.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" id="INEAVAL" accept="image/png, image/jpg, image/jpeg, application/pdf" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="avaline" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()" [disabled]="deshabilitarCampos" />
                                    </div>
                                </div>
                                <!-- === -->
                                <!-- INE -->
                                <!-- === -->
                                <!-- ========== -->
                                <!-- DOMICILIO  -->
                                <!-- ========== -->
                                <div class="form-group col-sm-12 col-md-12 col-lg-12">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.avalDomicilio.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" id="DOMICILIOAVAL" accept="image/png, image/jpg, image/jpeg, application/pdf" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="avaldomicilio" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()" [disabled]="deshabilitarCampos" />
                                    </div>
                                </div>
                                <!-- ========== -->
                                <!-- DOMICILIO  -->
                                <!-- ========== -->
                                <!-- ================= -->
                                <!-- ACTA CONSTITUTIVA -->
                                <!-- ================= -->
                                <div id="ACTA" hidden="true" class="form-group col-sm-12 col-md-12 col-lg-12">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.acta.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" data-show-loader="true" accept="image/png, image/jpg, image/jpeg, application/pdf" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="domicilio" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()" [disabled]="deshabilitarCampos" required/>
                                    </div>
                                </div>
                                <!-- ================= -->
                                <!-- ACTA CONSTITUTIVA -->
                                <!-- ================= -->
                                <!-- ============== -->
                                <!-- Poder Notarial -->
                                <!-- ============== -->
                                <div id="PODER" hidden="true" class="form-group col-sm-12 col-md-12 col-lg-12">
                                    <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.poder.titulo }}</label>
                                    <div class="col-md-12">
                                        <input type="file" class="archivoDocumento btn btn-outline-info" data-show-loader="true" accept="image/png, image/jpg, image/jpeg, application/pdf" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="domicilio" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()" [disabled]="deshabilitarCampos" required>
                                    </div>
                                </div>
                                <!-- ============== -->
                                <!-- Poder Notarial -->
                                <!-- ============== -->
                                <!-- ============== -->
                                <!-- Deposito en garantia -->
                                <!-- ============== -->
                                <div class="form-group col-sm-12 col-md-12 col-lg-12">
                                        <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.depositoGarantia.titulo }}</label>
                                        <div class="col-md-12">
                                            <input type="file" class="archivoDocumento btn btn-outline-info" id="DEPOSITOGARANTIA" accept="image/png, image/jpg, image/jpeg, application/pdf" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="50M" name="depositoGarantia" [(ngModel)]="pito" (ngModelChange)="cambiosEninputs()" [disabled]="deshabilitarCampos" required>
                                        </div>
                                    </div>
                                    <!-- ============== -->
                                    <!-- Deposito en garantia -->
                                    <!-- ============== -->
                                
                                            </div>
                                </div>
                        </div>
                        <!--Fin documentos-->
                        <br>
                        &nbsp;
                        <br>
                        <div *ngIf="btnGuardar" class="col-md-offset-3 col-md-6">
                            <label style="font-size: 20px">5.- Guardar el cliente</label>
                                <button type="button" class="btn btn-block colorGuardar" (click)="excepciones()">Guardar Cliente
                                    <i *ngIf="loginLoader" class="fa fa-spinner fa-pulse fa-fw"></i>
                                </button>
                            </div>
            </div>
        </div>
    </div>
 </div>
 <div class="modal fade" id="miModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="float float-none">Agregar contacto</h4>
                </div>
                <div class="modal-body">
                    <FORM class="form-horizontal form-material">
                        <div class="row">
                            <div class="col-sm-6">
                                <label>Nombre completo* :</label>
                                <input type='text' class="letras form-control" name="nombre" [(ngModel)]="nombreContacto" required minlength="3">
                            </div>
                            <div class="col-sm-6">
                                <label>Puesto:  <span class="help"> </span></label>
                                <input type='text' class="letras form-control" name="puesto" [(ngModel)]="puestoContacto">
                            </div>
                            <div class="col-sm-6">
                                <label>Correo: <span class="help"> </span></label>
                                <input type='text' class="correo form-control" name="correo" [(ngModel)]="correoContacto">
                            </div>
                            <div class="col-sm-6">
                                <label>Teléfono <span class="help"> </span></label>
                                <input type='text' class="form-control" [dropSpecialCharacters]="true" mask="(000) 0000-0000" name="telefono" [(ngModel)]="telContacto">
                            </div>
                            <div class="col-sm-6">
                                <label>Celular* :<span class="help"> </span></label>
                                <input type='text' class="form-control" [dropSpecialCharacters]="true" mask="(000) 0000-0000" name="celular" [(ngModel)]="celContacto" required minlength="3">
                            </div>
                        </div>
                    </FORM>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-info waves-effect botonconfirmar" type="button" data-dismiss="modal" (click)="armadoContactos()">
                        <!-- (click)="agregarContactos( response.Mensaje.cliente )" -->
                        Confirmar contacto
                    </button>
                </div>
            </div>
        </div>
    </div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/crear-cliente/crear-cliente.component.html